import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({ name: 'myLocalDateFormat' })
export class LocalDatePipe implements PipeTransform {

  public perpetuityLabel = '';

  constructor() {
  }

  public transform(
    value: any,
    currentLanguage: string,
    format: string
  ): string {

    if (currentLanguage === 'fr') {
      this.perpetuityLabel = 'Perpétuité';
    } else if (currentLanguage === 'en' || currentLanguage === 'de') {
      this.perpetuityLabel = 'Perpetuity';
    }

    if (value === '-' || value === this.perpetuityLabel) {
      return this.perpetuityLabel;
    }
    return new DatePipe(currentLanguage).transform(value, format);
  }
}
